import { render, staticRenderFns } from "./ExistingUser.vue?vue&type=template&id=813b45be&"
import script from "./ExistingUser.vue?vue&type=script&lang=js&"
export * from "./ExistingUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports